const RESOURCE_TYPES = {
  assignment: "Assignment",
  profile: "Profile",
  profileEducation: "ProfileEducation",
  profileLink: "ProfileLink",
  profileSchedule: "ProfileSchedule",
  profileVacation: "ProfileVacation",
  profileWorkExperience: "ProfileWorkExperience",
  profileList: "ProfileList",
  timeCard: "TimeCard",
  timeSlip: "TimeSlip",
  interviewResponse: "InterviewResponse",
  missionRoleApplicant: "MissionRoleApplicant",
  missionRoleInvitation: "MissionRoleInvitation",
  missionInterviewCreated: "MissionInterview",
  comment: "Comment",
  coderbyteChallengeResponse: "CoderbyteChallengeResponse",
  deelInvoicesTask: "DeelInvoicesTask",
  missionRole: "MissionRole",
  missionRoleChallenge: "MissionRoleChallenge",
  locatable: "Locatable",
  taggable: "ActsAsTaggableOn::Tagging",
  missionRoleQuestion: "AssessmentQuestion",
};

const POLYMORPHIC_RESOURCE_TYPES = {
  [RESOURCE_TYPES.locatable]: {
    MissionRole: "role",
    relatedEntities: ["mission"],
  },
  [RESOURCE_TYPES.taggable]: {
    MissionRole: "role",
    relatedEntities: ["mission"],
  },
};

export { POLYMORPHIC_RESOURCE_TYPES };

export default RESOURCE_TYPES;
